/**
 * Mobile: Klaviyo-Popup & Teaser erst nach Verzögerung / Scroll — Footer-Embed bleibt.
 */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  var DELAY_MS = 30000;
  var SCROLL_RATIO = 0.2;
  var allowed = false;
  var root = document.documentElement;

  root.classList.add('moos-klaviyo-suppressed');

  function isFooterKlaviyo(node) {
    return Boolean(
      node.closest(
        '.footer, #shopify-section-footer-group, .shopify-section-group-footer-group, [id*="footer"]'
      )
    );
  }

  function suppressPopups() {
    if (allowed) return;

    document.querySelectorAll('form.klaviyo-form, .klaviyo-form, [class*="klaviyo"]').forEach(function (node) {
      if (isFooterKlaviyo(node)) return;

      var form = node.matches('form.klaviyo-form, .klaviyo-form') ? node : node.closest('form.klaviyo-form, .klaviyo-form');
      if (!form || isFooterKlaviyo(form)) return;

      var style = window.getComputedStyle(form);
      if (style.position === 'fixed' || form.getAttribute('role') === 'dialog' || form.closest('[role="dialog"]')) {
        form.classList.add('moos-klaviyo-hidden');
      }
    });

    document.querySelectorAll('.kl-teaser, [data-testid="FLYOUT"], [class*="kl-teaser"]').forEach(function (node) {
      if (!isFooterKlaviyo(node)) {
        node.classList.add('moos-klaviyo-hidden');
      }
    });
  }

  function allowKlaviyo() {
    if (allowed) return;
    allowed = true;
    root.classList.remove('moos-klaviyo-suppressed');
    document.querySelectorAll('.moos-klaviyo-hidden').forEach(function (node) {
      node.classList.remove('moos-klaviyo-hidden');
    });
  }

  function maybeAllowEarly() {
    var scrolled =
      (window.scrollY + window.innerHeight) / Math.max(document.documentElement.scrollHeight, 1) >= SCROLL_RATIO;
    if (scrolled) allowKlaviyo();
  }

  var observer = new MutationObserver(suppressPopups);
  observer.observe(document.body, { childList: true, subtree: true });

  suppressPopups();
  window.setTimeout(allowKlaviyo, DELAY_MS);
  window.addEventListener('scroll', maybeAllowEarly, { passive: true });
  document.addEventListener('visitorConsentCollected', function () {
    window.setTimeout(allowKlaviyo, 5000);
  });
})();
